export default __webpack_public_path__ + "static/media/slew_logo.8970bb69.png";